enum PickListRowStepEnum {
    GATHERED = 1,
    FILLED,
    BOXED,
}

export default PickListRowStepEnum;
